export default __webpack_public_path__ + "static/media/ethereal1.89dc3361.jpeg";